/**
 * Re-ranks the search results grid to match predictive search product order.
 * Storefront search and predictive search use different Shopify engines; this
 * keeps the first page aligned with the drawer for the same query.
 */
class SearchPredictiveAlign {
  static init() {
    const grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.searchContext !== 'true') {
      return;
    }

    if (grid.dataset.predictiveAlignPending === 'true') {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const q = params.get('q');
    if (!q || !SearchPredictiveAlign.shouldAlign(params)) {
      return;
    }

    grid.dataset.predictiveAlignPending = 'true';

    const fetchUrl = `${theme.routes.predictive_search_url}?q=${encodeURIComponent(q)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[options][fields]')}=title,product_type,tag,variants.title&section_id=predictive-search`;

    fetch(fetchUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const cards = doc.querySelectorAll('product-card[data-product-id]');
        if (!cards.length) {
          return;
        }

        const predictiveIds = [];
        const handles = [];

        cards.forEach((card) => {
          predictiveIds.push(card.dataset.productId);
          const link = card.querySelector('a[href*="/products/"]');
          if (!link) {
            return;
          }

          const href = link.getAttribute('href') || '';
          const handle = href.split('/products/').pop().split('?')[0].split('#')[0];
          if (handle) {
            handles.push(handle);
          }
        });

        if (!handles.length) {
          return;
        }

        return SearchPredictiveAlign.mergeGrid(grid, handles, predictiveIds);
      })
      .catch(() => {})
      .finally(() => {
        delete grid.dataset.predictiveAlignPending;
        grid.dataset.predictiveAligned = 'true';
      });
  }

  static shouldAlign(params) {
    const sortBy = params.get('sort_by') || 'relevance';
    const page = params.get('page') || '1';

    if (sortBy !== 'relevance' || page !== '1') {
      return false;
    }

    for (const key of params.keys()) {
      if (key.startsWith('filter.')) {
        return false;
      }
    }

    return true;
  }

  static mergeGrid(grid, handles, predictiveIds) {
    const handleQuery = handles.map((handle) => `handle:${handle}`).join(' OR ');
    const cardUrl = `${theme.routes.search_url}?view=recently-viewed&type=product&q=${encodeURIComponent(handleQuery)}`;

    return fetch(cardUrl)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fetchedItems = [...doc.querySelectorAll('li.column')];
        if (!fetchedItems.length) {
          return;
        }

        const getItemId = (item) => item.dataset.productId || item.querySelector('product-card')?.dataset.productId;

        const fetchedById = new Map();
        fetchedItems.forEach((item) => {
          const id = getItemId(item);
          if (!id) {
            return;
          }
          item.dataset.productId = id;
          fetchedById.set(id, item);
        });
        const existingItems = [...grid.querySelectorAll('li.column[data-product-id]')];
        const pageSize = existingItems.length;
        const existingById = new Map(existingItems.map((item) => [item.dataset.productId, item]));
        const predictiveIdSet = new Set(predictiveIds);
        const merged = [];

        predictiveIds.forEach((id) => {
          const item = fetchedById.get(id) || existingById.get(id);
          if (item) {
            merged.push(item);
          }
        });

        existingById.forEach((item, id) => {
          if (!predictiveIdSet.has(id)) {
            merged.push(item);
          }
        });

        grid.replaceChildren(...merged.slice(0, pageSize));
      });
  }
}

window.addEventListener('load', () => {
  SearchPredictiveAlign.init();
});
